import router from './router'
import SaleMessages from './localization'

export default {
  router,
  localization: SaleMessages,
}
